import React, {useState} from "react";
import help_img from "../img/information-line.png"
import logo_eco from "../img/Logo eco by assur bon plan.png"
import DataDevis from "../dataDevis";
import logo_abp from "../img/Logo assur bon plan.png"

/*
const OptionRow = (props) => {

    const [unfolded,setUnfolded] = useState(false)

    const {devis,changeParams,showValidate,focusError} = props.container
    const params = devis.params
    let selectedOptions = params.selectedOptions || []
    const w = props.w
    const checked = selectedOptions.includes(w.Z_CODOPT)
    const periodicite = params.periodicite
    const mkClassName = (p,base) => {
        return ( checked &&( p == periodicite ) )?( base+' selected' ): base
    }

    const onChange = ()=>{
        // Prevent IPx and ACx to be selected at once
        switch ( w.Z_CODOPT ) {
            case 'IP1':
                selectedOptions = selectedOptions.filter( e => e!='IP2' )
                break;
            case 'IP2':
                selectedOptions = selectedOptions.filter( e => e!='IP1' )
                break;
            case 'AC1':
                selectedOptions = selectedOptions.filter( e => e!='AC2' )
                break;
            case 'AC2':
                selectedOptions = selectedOptions.filter( e => e!='AC1' )
                break;
        }
        if ( selectedOptions.includes(w.Z_CODOPT) ) {
            changeParams( {selectedOptions:selectedOptions.filter( e=>e!=w.Z_CODOPT ) } )
        } else {
            changeParams( {selectedOptions: [...selectedOptions,w.Z_CODOPT] } )
        }
    }

    return <React.Fragment  key={w.Z_CODOPT}>
        <tr><td colSpan="2" className="ttitle">
        <div className="ttitle"
            onClick={e=>{ setUnfolded( (v)=>!v ) } }
        >
        <label>
            
        {w.Z_CODOPT} {w.ZZ0_LIBOPT.replace('?','é').replace('XENASSUR ASSISTANCE','ASSISTANCE ASSUR BON PLAN')} </label><img className="help_button" src={help_img} title="Informations sur cette option"/></div></td></tr>
        <tr onClick={onChange}><td className={mkClassName('A','ttarif col1')}>{devis.fancyPrice(w.Z_MTAOP)} €</td><td className={mkClassName('M','ttarif col3')}>{devis.fancyPrice(w.Z_MTMOP)} €</td></tr>
        <tr className={unfolded?'':'folded'}><td colSpan="2">{devis.getOptionText(w.Z_CODOPT)}</td></tr>
    </React.Fragment>
}
*/


const OptionRow = (p) => {

    const {oneColumn,xena,periodicite,formule,changeParams,selectedOptions,detailSwitch} = p.container
    let w = xena.find( w => w.Z_CODOPT==p.xenaKey )
    if (( p.xenaKey == 'AC1' || p.xenaKey == 'AC2' )&&( formule == 'M2' )) w = undefined

    const checked = selectedOptions.includes(p.xenaKey)
    const sollyChecked = false

    const onChange = ()=>{
        let s = selectedOptions
        // Prevent IPx and ACx to be selected at once
        switch ( p.xenaKey ) {
            case 'IP1':
                s = s.filter( e => e!='IP2' )
                break;
            case 'IP2':
                s = s.filter( e => e!='IP1' )
                break;
            case 'AC1':
                s = s.filter( e => e!='AC2' )
                break;
            case 'AC2':
                s = s.filter( e => e!='AC1' )
                break;
        }
        if ( s.includes(p.xenaKey) ) {
            changeParams( {selectedOptions:s.filter( e=>e!=p.xenaKey ) } )
        } else {
            changeParams( {selectedOptions: [...s,p.xenaKey] } )
        }
    }

    return <tr><td>{p.children}
    </td><td 
        className={checked ? 'tarif selected' : 'tarif'}
        onClick={onChange}
    >
    { w ? <>{DataDevis.fancyPrice(( periodicite == 'M' )?w.Z_MTMOP:w.Z_MTAOP)} € 
        <span onClick={(e)=> { detailSwitch(p.xenaKey) ; e.stopPropagation() }}>Voir +</span>
        </> :<i>Non disponible</i>}
    </td>
    {oneColumn?<></>:<td 
        className={ sollyChecked ?'tarif selected':'tarif'}
        >
        <i>Non disponible</i>
    </td>}
    </tr>
}


const DetailRow = (p) => {
    return p.unfold.includes(p.xenaKey) ? <tr><td className="formule_details" colSpan={p.oneColumn?2:3}>{p.children}</td></tr> : <></>
}

export default (props) => {

    const [unfold,setUnfold] = useState([])

    const detailSwitch = (code)=>{
        if ( unfold.includes(code) ) {
            setUnfold( unfold.filter(c=>c!=code))
        } else {
            setUnfold([code,...unfold])
        }
    }
    const {devis,changeParams} = props.container
    const {solly_ref,solly_tarifs,params} = devis
    const oneColumn = ! solly_ref
    const colSpan = oneColumn ? 2 : 3
    const {options,periodicite,formule,selectedOptions} = params
    const container = {
        xena:options,
        sollyRef:solly_ref,
        oneColumn:oneColumn,
        periodicite:periodicite,
        formule:formule,
        changeParams:changeParams,
        selectedOptions:selectedOptions || [],
        detailSwitch:detailSwitch
    }
    if ( ! options ) return <></>
    return <table className={oneColumn?'comparateur onecolumn':'comparateur'}>
        <thead>
            <tr><th></th><th><img src={logo_eco}/></th>{oneColumn?<></>:<th><img src={logo_abp}/></th>}</tr>
        </thead>
        <tbody>

            <tr><th colSpan={colSpan}>Assistance</th></tr>
            <OptionRow xenaKey="AST" container={container}>
                <h3>Assistance Plus 0 km + véhicule de remplacement</h3>
            </OptionRow>
            <DetailRow xenaKey="AST" unfold={unfold} oneColumn={oneColumn}>
            <p>Assistance pour l'assuré, son passager et son deux-roues, 24h/24 -
            7j/7, en cas de panne, accident, vol, tentative de vol ou crevaison, perte de
            clefs et enlèvement par la fourrière.
            Incluant un véhicule de remplacement (auto ou moto*) pour toute durée d’immobilisation
            supérieure à 48h (3 jours suite à une panne, 5 jours suite à un accident et 15 jours suite à
            un vol du véhicule).
            </p>
            </DetailRow>
            <tr><th colSpan={colSpan}>Assurance Individuelle Pilote</th></tr>
            <OptionRow xenaKey="IP1" container={container}>
                <h3>Jusqu'à 300 000 €</h3>
                <b>Nous vous <u>recommandons</u> cette option !</b>
            </OptionRow>
            <DetailRow xenaKey="IP1" unfold={unfold} oneColumn={oneColumn}>
                <p>Garantie du versement d’indemnités à vous ou à vos ayants droit en cas d’accident au guidon de votre deux-roues à hauteur de 300000€. 
                </p>
            </DetailRow>
            <OptionRow xenaKey="IP2" container={container}>
                <h3>Jusqu'à 800 000 €</h3>
            </OptionRow>

            <DetailRow xenaKey="IP2" unfold={unfold} oneColumn={oneColumn}>
            <p>Assurance pilote à hauteur de 800000€. 
            </p>
            </DetailRow>
            <tr><th colSpan={colSpan}>Assurance accessoire</th></tr>
            <OptionRow xenaKey="AC1" container={container}>
                <h3>Jusqu'à 1 000 €</h3>
            </OptionRow>

            <DetailRow xenaKey="AC1" unfold={unfold} oneColumn={oneColumn}>
            <p>Garantie du remboursement des accessoires hors-série et équipement vestimentaire de protection du motard jusqu’à 1000 €. Remboursement à la valeur d’achat pour les véhicules acquis neufs depuis moins de 18 mois. </p>
            </DetailRow>
            <OptionRow xenaKey="AC2" container={container}>
                <h3>Jusqu'à 10 000 €</h3>
            </OptionRow>

            <DetailRow xenaKey="AC2" unfold={unfold} oneColumn={oneColumn}>
            <p>Assurance Accessoires jusqu’à 10000€. Remboursement à la valeur d’achat pour les véhicules acquis neufs depuis moins de 18 mois. 
            </p>
            </DetailRow>


        </tbody>
    </table>
}